"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FontWeightEnum_1 = require("../enums/FontWeightEnum");
var TextAlignmentEnum_1 = require("../enums/TextAlignmentEnum");
var TextCaseEnum_1 = require("../enums/TextCaseEnum");
exports.defaultTheme = {
    // Border Radius
    BorderRadiusAvatarSmall: 12,
    BorderRadiusAvatarSmallSquare: 1,
    BorderRadiusAvatarMedium: 24,
    BorderRadiusAvatarMediumSquare: 4,
    BorderRadiusAvatarBig: 32,
    BorderRadiusAvatarBigSquare: 8,
    BorderRadiusDateIndicator: 12,
    BorderRadiusButton: 10,
    BorderRadiusFilterChip: 16,
    BorderRadiusFloatingButton: 24,
    BorderRadiusCard: 4,
    // Border Width
    BorderWidthAvatar: 0,
    BorderWidthButton: 1,
    BorderWidthCard: 1,
    // Colors
    ColorNone: 'transparent',
    ColorBackground: '#E8E8E8',
    ColorSurface: '#FFFFFF',
    ColorLowContrast: '#A1A1A1',
    ColorMediumContrast: '#757575',
    ColorHighContrast: '#494949',
    ColorBrand1Low: '#74ACB7',
    ColorBrand1Default: '#457D87',
    ColorBrand1High: '#0D5B65',
    ColorComplementary1: '#FFFFFF',
    ColorBrand2Low: '#FF8DE4',
    ColorBrand2Default: '#FF58B2',
    ColorBrand2High: '#C81582',
    ColorComplementary2: '#000000',
    ColorDanger: '#EB0037',
    ColorAlert: '#E87300',
    ColorSuccess: '#008900',
    ColorInfo: '#006BFF',
    // Font Family
    FontFamilySystem: undefined,
    FontFamilyBrand: undefined,
    // Font Size
    FontSizeButton: 12,
    FontSizeAuxiliary: 12,
    FontSizeBody: 14,
    FontSizeHeading: 18,
    FontSizeHighlight: 16,
    FontSizeDisplay: 24,
    // Font Weight
    FontWeightStrong: FontWeightEnum_1.FontWeightEnum.bold,
    FontWeightNormal: FontWeightEnum_1.FontWeightEnum.normal,
    FontWeightLight: FontWeightEnum_1.FontWeightEnum.light,
    // Height
    HeightButtonBase: 48,
    HeightButtonAuxiliary: 32,
    HeightDivider: 1,
    HeightFilterChip: 32,
    HeightImageCard: 192,
    HeightImageLogo: 120,
    // Line Height
    LineHeightBase: 20,
    LineHeightHeading: 24,
    LineHeightDisplay: 32,
    // Multiline Limit
    MultilineLimitBody: undefined,
    MultilineLimitComment: 2,
    MultilineLimitCommentPreview: 1,
    MultilineLimitHeading: 1,
    MultilineLimitPost: 2,
    // Opacity
    OpacityDisabled: 0.3,
    OpacityImageOverlay: 0.8,
    // Proportions
    ProportionWidest: '2:1',
    ProportionWide: '16:9',
    ProportionSquare: '1:1',
    // Size
    SizeAvatarSmall: 24,
    SizeAvatarMedium: 48,
    SizeAvatarBig: 64,
    SizeIconBase: 24,
    SizeIconAuxiliary: 16,
    SizeFloatingButton: 48,
    // Spacing
    SpacingAtomic: 4,
    SpacingBase: 8,
    SpacingMarginal: 16,
    SpacingDistribute: 24,
    SpacingIntersection: 48,
    SpacingWide: 64,
    SpacingButtonMarginHorizontal: 48,
    SpacingInputMarginHorizontal: 24,
    // Text Alignment
    TextAlignmentButton: TextAlignmentEnum_1.TextAlignmentEnum.center,
    TextAlignmentH1: TextAlignmentEnum_1.TextAlignmentEnum.center,
    TextAlignmentH2: TextAlignmentEnum_1.TextAlignmentEnum.center,
    TextAlignmentH3: TextAlignmentEnum_1.TextAlignmentEnum.center,
    TextAlignmentH4: TextAlignmentEnum_1.TextAlignmentEnum.center,
    // Text Case
    TextCaseButton: TextCaseEnum_1.TextCaseEnum.uppercase,
    TextCaseHeading: TextCaseEnum_1.TextCaseEnum.none,
    //Width
    WidthGenericListItemButton: 72,
    WidthImagePickerButton: 120,
    WidthThread: 1
};
